import { AuthScreen } from '@/components/domain/auth/AuthScreen';
import { SignUpForm } from '@/components/domain/auth/SignUpForm';

export default function SignUpScreen() {
  return (
    <AuthScreen title="Create your account" subtitle="Two steps to your first run.">
      <SignUpForm />
    </AuthScreen>
  );
}
